import { FunctionComponent } from 'react'
import { useProfessionalSearch } from './ProfessionalSearch.hook'
import {
  Breadcrumbs,
  Flex,
  getTheme,
  Stack,
  Button,
  Pagination,
  PaginationOptions,
  Text,
} from '@conexasaude/conexa-hero'
import { breadcrumbItems } from '../ProfessionalAppointment/ProfessionalAppointment.constants'
import { Link } from 'react-router-dom'
import DivisorLine from '@/components/DivisorLine'
import RenderIf from '@/components/RenderIf'
import NoResults from '../ProfessionalAppointment/components/NoResults'
import { PROFESSIONALS_PER_PAGE } from '../ProfessionalAppointment/components/PsychologistCard/constants'
import ProfessionalBookingCard from '../ProfessionalAppointment/ProfessionalBookingCard/ProfessionalBookingCard.component'

const ProfessionalSearch: FunctionComponent = () => {
  const theme = getTheme()
  const {
    isLoading,
    professionals,
    page,
    showPagination,
    showNoResults,
    professionalsPaginationCount,
    handleChangePage,
    handleNewProfessionalSearch,
  } = useProfessionalSearch()

  return (
    <Stack gap={theme.spacing.xs} pb={theme.spacing.xs}>
      <Stack gap={2}>
        <Breadcrumbs.Root>
          {breadcrumbItems.map(item => {
            return (
              <Breadcrumbs.Item key={item?.id} active={item?.active}>
                <Link to="/atendimento/agendar/consulta">{item?.label}</Link>
              </Breadcrumbs.Item>
            )
          })}
        </Breadcrumbs.Root>
        <DivisorLine />

        <Flex justify="flex-end">
          <Button onClick={handleNewProfessionalSearch}>
            Realizar nova busca
          </Button>
        </Flex>
      </Stack>

      <RenderIf condition={isLoading}>
        <Flex
          direction="column"
          justify="center"
          align="center"
          mt={theme.spacing.md}
          gap={theme.spacing.xs}
        >
          <Flex maw={400}>
            <Text variant="subheading" textAlign="center">
              Buscando profissionais...
            </Text>
          </Flex>
        </Flex>
      </RenderIf>

      {professionals?.items?.map(professional => (
        <ProfessionalBookingCard
          key={professional?.professional?.id}
          professional={professional?.professional}
          startDateSlot={professional?.professional?.startDateSlot}
        />
      ))}

      <RenderIf condition={showNoResults}>
        <NoResults />
      </RenderIf>

      <RenderIf condition={showPagination}>
        <Flex
          justify="center"
          align="center"
          gap="sm"
          mt="md"
          direction={{ base: 'column', sm: 'row' }}
        >
          <Pagination
            defaultPage={1}
            prevLabel="Anterior"
            nextLabel="Próximo"
            count={professionalsPaginationCount}
            page={page}
            onChange={(_, page) => handleChangePage(page)}
          />

          <PaginationOptions
            currentPage={page}
            totalItems={professionals?.total}
            valuePerPage={PROFESSIONALS_PER_PAGE}
          />
        </Flex>
      </RenderIf>
    </Stack>
  )
}

export default ProfessionalSearch
